export const OrderInitiatorValues = ['user', 'shares', 'broker', 'bo'] as const;

export type OrderInitiator = (typeof OrderInitiatorValues)[number];

export const FeeFreeReasonValues = [
  'affiliate_fr',
  'investment_plan',
  'waived_from_fees_ip',
  'referral_fee_free_trade',
  'marketing_campaign_reward',
  'position_liquidation',
  'pea_transfer',
  'pea_amundi_etf_buy',
] as const;

export type FeeFreeReason = (typeof FeeFreeReasonValues)[number];

export const B2BFeeFreeReasonValues = [
  'fully_managed_plan',
  'remainder_allocation_order',
  'fee_charge_order',
  'b2c_order',
  'b2b_omnibus_rebalance',
] as const;

export type B2BFeeFreeReason = (typeof B2BFeeFreeReasonValues)[number];
